// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGResizeExpand = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M1.857 9.286c.315 0 .572.257.572.571v3.194l3.594-3.594c.223-.223.583-.223.806 0 .223.223.223.583 0 .806l-3.595 3.594H6.43c.314 0 .571.257.571.572 0 .314-.257.57-.571.57H1.852c-.027 0-.055-.002-.081-.006l-.028-.005-.02-.005-.032-.008-.02-.007c-.08-.028-.154-.072-.22-.134-.118-.118-.173-.275-.165-.43V9.857c0-.314.257-.571.571-.571zM9.857 7h-.005.005zM14.429 1.286c.314 0 .571.257.571.571v4.571c0 .315-.257.572-.571.572-.315 0-.572-.257-.572-.572V3.234l-3.6 3.6c-.113.114-.255.165-.403.165-.147 0-.289-.057-.402-.165-.223-.223-.223-.583 0-.806l3.6-3.6H9.856c-.314 0-.571-.257-.571-.57 0-.315.257-.572.571-.572h4.572z"
  })
}));
SVGResizeExpand.displayName = 'SVGResizeExpand';
export default SVGResizeExpand;